import React from 'react';
import styles from './Input.module.css';
import taStyles from './Textarea.module.css';

class Textarea extends React.Component {
  constructor(props) {
    super(props);
    this.state = { focused: false };
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur  = this.handleBlur.bind(this);
  }

  handleFocus() { this.setState({ focused: true }); }
  handleBlur()  { this.setState({ focused: false }); }

  render() {
    const {
      label, hint, error, required, counter,
      rows = 3, resize = true, size = 'md',
      value, onChange, placeholder, maxLength, disabled,
      style,
    } = this.props;

    const { focused } = this.state;

    const wrapCls = [
      styles.fieldWrap,
      taStyles.taWrap,
      focused ? styles.focused : '',
      error   ? styles.error   : '',
    ].filter(Boolean).join(' ');

    return (
      <div className={styles.wrap} style={style}>
        {label && (
          <label className={styles.label}>
            {label}
            {required && <span className={styles.required}>*</span>}
          </label>
        )}
        <div className={wrapCls}>
          <textarea
            className={[styles.input, styles[size], taStyles.ta].join(' ')}
            rows={rows}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            style={{ resize: resize ? 'vertical' : 'none' }}
          />
        </div>
        {counter && maxLength && (
          <div className={styles.counter}>
            {(value || '').length} / {maxLength}
          </div>
        )}
        {hint  && !error && <div className={styles.hint}>{hint}</div>}
        {error && <div className={styles.err}>{error}</div>}
      </div>
    );
  }
}

export default Textarea;
